import Base from "./base";
import {
  UNFAVOURITE,
  FAVOURITE_EVENT_INDEX,
  CREATE_WITH_PROFILE_ID,
  CHECK_FAVOURITE
} from "@/utils/api-url";
import apiDispatcher from "@/utils/api-dispatcher";

export default class Favourite extends Base {
  constructor(params = {}) {
    super(params);

    this.name = this.collegeName || this.clubName || this.athletename || "";
    this.imageUrl = this.imageUrl || "";
    this.date = (this.date && new Date(this.date).toDateString()) || "";
    this.state =
      (params["state"] && params["state"]["name"]) ||
      this.state ||
      this.stateName ||
      "";
    this.division =
      (params["division"] && params["division"]["name"]) ||
      this.divisionName ||
      this.division ||
      "";
    this.city =
      (params["city"] && params["city"]["name"]) ||
      this.cityName ||
      this.city ||
      "";
    this.eventType =
      (params["eventType"] && params["eventType"]["name"]) ||
      this.eventName ||
      "";
    this.address1 = params["address1"] || this.address1 || "";
    this.age = (params["age"] && params["age"]["name"]) || this.age || "";
    this.graduationYear = params["graduationYear"] || this.graduationYear || "";
    this.gpa = params["gpa"] || this.gpa || "";
  }

  static resourceName() {
    return "fav";
  }

  static unfavourite(params) {
    return apiDispatcher(UNFAVOURITE(params));
  }

  static index(params) {
    return apiDispatcher(FAVOURITE_EVENT_INDEX(params));
  }

  static create(body) {
    return apiDispatcher(CREATE_WITH_PROFILE_ID(body, "fav", this.profileId()));
  }

  static checkFavourite(params) {
    return apiDispatcher(CHECK_FAVOURITE(this.profileId(), params.id));
  }
}
